
import BatteryEmpty from "../../../assets/outline/BatteryEmpty.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BatteryEmptyIcon({ className, dataTestid = "BatteryEmptyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BatteryEmpty data-testid={dataTestid} className={classes} {...rest} />
  );
}
